import { Component, OnInit } from '@angular/core';
import { footerService } from './footer.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import Swal from 'sweetalert2';
import packageInfo from '../../../../../../package.json';

@Component({
  selector: 'footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit {

  versionFront = '';
  versionBack = '';
  versionDB = '';
  releaseFront = '';
  releaseBack = '';

  private _unSubscribeAll: Subject<any>;

  constructor(
    private footerService: footerService,
  ) {
    this._unSubscribeAll = new Subject();
  }

  ngOnInit() {
    this.footerService.getAppVersion()
      .pipe(takeUntil(this._unSubscribeAll))
      .subscribe((data: any) => {
        this.versionFront = packageInfo.version;
        this.releaseFront = packageInfo.release;
        this.versionBack = data.VERSION_BACK;
        this.releaseBack = data.RELEASE_BACK;
        this.versionDB = data.VERSION_DB;
      });
  }

  showVersion() {
    Swal.fire({
      title: 'FTAGo!',
      html: `<span style="font-size: medium; text-align: left;">
              La aplicación se encuentra en las siguientes versiones
              de cada uno de sus componentes:<br>
              <ul>
                <li>FrontEnd: ${this.versionFront}</li>
                ${this.releaseFront}
                <li>BackEnd: ${this.versionBack}</li>
                ${this.releaseBack}
                <li>DataBase: ${this.versionDB}</li>
              </ul>
            </span>`,
      icon: 'info',
      showCancelButton: false,
      showConfirmButton: false,
      allowEscapeKey: true,
      allowOutsideClick: true
    });
  }

}
